import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./index.css";
import { Navigation } from "./navigation";
import { useDocTitle } from "./components/CustomHook";
import Chatbot from "./components/chatbot"; // ✅ Updated import
import { RequestCallback } from "./components/RequestCallBack";


function App() {
  useEffect(() => {
    const aos_init = () => {
      AOS.init({
        once: true,
        duration: 1000,
        easing: "ease-out-cubic",
      });
    };
    window.addEventListener("load", aos_init);
    return () => window.removeEventListener("load", aos_init);
  }, []);

  useDocTitle("Lakche -  Software Developement Company");

  return (
    <>
      <Navigation />
      <Chatbot />
      <RequestCallback />
    </>
  );
}

export default App;
